const ACC_NAV_KEYS = new Set([
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
])

const ACC_NAV_ACTION_KEYS = new Set(['Enter', ' '])

export function resolveNextAccNavIndex(key, currentIndex, lastIndex) {
  switch (key) {
    case 'ArrowLeft':
    case 'ArrowUp':
      return Math.max(0, currentIndex - 1)
    case 'ArrowRight':
    case 'ArrowDown':
      return Math.min(lastIndex, currentIndex + 1)
    case 'Home':
      return 0
    case 'End':
      return lastIndex
    default:
      return currentIndex
  }
}

export default {
  data() {
    return {
      accNavFocusedIndex: 0,
    }
  },
  watch: {
    items() {
      this.accNavFocusedIndex = 0
    },
  },
  methods: {
    onAccNavActionKeydown(event, action) {
      if (event.shiftKey || event.ctrlKey || event.metaKey || event.altKey) {
        return
      }

      if (!ACC_NAV_ACTION_KEYS.has(event.key)) return

      event.preventDefault()
      action()
    },
    onAccNavKeydown(event) {
      if (event.shiftKey || event.ctrlKey || event.metaKey || event.altKey) {
        return
      }

      if (!ACC_NAV_KEYS.has(event.key)) return

      const lastIndex = this.items.length - 1
      if (lastIndex < 0) return

      event.preventDefault()

      const nextIndex = resolveNextAccNavIndex(
        event.key,
        this.accNavFocusedIndex,
        lastIndex
      )
      if (nextIndex === this.accNavFocusedIndex) return

      this.accNavFocusedIndex = nextIndex
      this.$nextTick(() => this.focusAccNavItem(nextIndex))
    },
    focusAccNavItem(index) {
      const item = this.$refs.accNavItems?.[index]
      if (item?.focus) item.focus()
    },
    focus() {
      if (this.$el) this.$el.focus()
    },
  },
}
